import defineComponent from 'flight';
import isTouch from 'static/script/utils/is-touch';
import SideMenuBgUI from 'static/script/app/ui/layout/side-menu-bg-ui';

function BodyContainer() {
    this.defaultAttrs({
        menuAnimationContainer: '[data-side-menu-animation]',
        loginLink: '[data-login-link]',
        sideMenuBgSelector: '[data-side-menu-bg]',
        initData: null
    });

    this._toggleAjaxSpinner = function(e) {
        this.$node.toggleClass(
            'page-loading',
            e.type === 'data:navigation:before-page-load'
        );
    };

    this._beforePageChange = function() {
        this.$node.removeClass('site-header-search-active');
        this.$node.removeClass('page-loaded');
        this._closeSideMenu();
    };

    this._toggleSidemenu = function() {
        this._animateSideMenu(
            function() {
                if (this.$node.hasClass('side-menu-active')) {
                    this._closeSideMenu();
                } else {
                    this.$node.addClass('side-menu-active');
                }
            }.bind(this)
        );
    };

    this._animateSideMenu = function(setTargetState) {
        this.select('menuAnimationContainer').addClass('side-menu-animating');
        this._triggerLayout();
        setTargetState();
        this._afterAnimation(function() {
            this.select('menuAnimationContainer').removeClass(
                'side-menu-animating'
            );
        });
    };

    this._triggerLayout = function() {
        return this.$node.innerHeight;
    };

    this._afterAnimation = function(fn) {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
        }
        this.animationTimer = setTimeout(fn.bind(this), 500);
    };

    this._closeSideMenu = function() {
        this.$node.removeClass('side-menu-active');
        this.trigger(document, 'ui:body-container:after-side-menu-close');
    };

    this._updateLoginUrl = function() {
        let loginLink = this.select('loginLink');

        if (loginLink.length > 0) {
            let returnTo =
                '?ReturnUrl=' +
                encodeURIComponent(
                    window.location.pathname + window.location.search
                );

            loginLink.each(function() {
                let link = $(this);

                if (!link.attr('data-base-url')) {
                    link.attr('data-base-url', link.attr('href'));
                }

                link.attr('href', link.attr('data-base-url') + returnTo);
            });
        }
    };

    this._toggleHoverEffects = function(disable) {
        this.$node.toggleClass('disable-hover', disable);
    };

    this._initSideMenuBg = function() {
        if (this.select('sideMenuBgSelector').length < 1) {
            this._sideMenuBg = $(
                '<div class="side-menu-bg" data-side-menu-bg></div>'
            );
            this._sideMenuBg.prependTo(this.select('menuAnimationContainer')); // This is slow and must be done after attaching the attachTo()
        }

        SideMenuBgUI.attachTo(this.select('sideMenuBgSelector'));
    };

    this.after('initialize', function() {
        this._updateLoginUrl();
        this._initSideMenuBg();

        this.on(document, 'ui:before-page-change', this._beforePageChange);
        this.on(
            document,
            'data:navigation:before-page-load data:navigation:after-page-load',
            this._toggleAjaxSpinner
        );
        this.on(
            document,
            'ui:site-header:on-hamburger-click ui:side-menu:on-side-menu-close-click',
            this._toggleSidemenu
        );
        this.on(
            document,
            'ui:navigation:after-page-change',
            this._closeSideMenu
        );
        this.on(
            document,
            'data:navigation:after-page-load',
            this._updateLoginUrl
        );

        if (!isTouch() && this.attr.initData.disableHoverOnScroll === true) {
            this.on(document, 'utils:window-scroll:on-start', function() {
                this._toggleHoverEffects(true);
            });

            this.on(document, 'utils:window-scroll:on-stop', function() {
                this._toggleHoverEffects(false);
            });
        }

        this.$node.addClass('page-loaded');
    });
}

export default defineComponent.component(BodyContainer);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/body-container.js